/**
 * Build-time feature flag for the TILE GIF-hover animation (EW-003, ISP-9999).
 *
 * A GIF wedge freezes to its poster frame inside an SVG <image> (EW-009), so on a
 * gallery/explore tile the gif shows as a still. When this flag is ON, hovering a
 * tile (web) / focusing it (mobile/keyboard) mounts an animating HTML <img> of the
 * SAME gif over each gif wedge, pixel-aligned to the frozen poster, then removes it
 * off-hover — GPU-light (a plain <img>, no JS animation loop) and reduced-motion
 * safe (the mount is skipped when the user prefers reduced motion).
 *
 * Mirrors segmentArcFillsFlag.js: defaults OFF, flipped per environment via
 * REACT_APP_TILE_GIF_HOVER. Independent of REACT_APP_SEGMENT_ARC_FILLS so the
 * static wedge fill and the hover animation can roll out separately. When OFF, no
 * hover listeners are wired and the tile renders byte-identical to the static-fill
 * build.
 */
const truthy = (v) => v === "true" || v === "1" || v === true;

export const TILE_GIF_HOVER_ENABLED = truthy(process.env.REACT_APP_TILE_GIF_HOVER);
